import { type FC, type MouseEventHandler, useState } from 'react';
import { Button, Group } from '@mantine/core';
import { useDeclinePayinOrder } from '~/entities/payin';
import { ConfirmationDialog } from '~/shared/ui/ConfirmationDialog';

export interface DeclineProps {
    id: string;
    onDecline?: VoidFunction;
    onSuccess?: VoidFunction;
    onError?: (error: Error) => void;
}

export const Decline: FC<DeclineProps> = ({ id, onDecline, onSuccess, onError }) => {
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);

    const { mutate, isPending } = useDeclinePayinOrder({
        onSuccess: () => {
            setIsDeleteConfirmationOpen(false);
            onSuccess?.();
        },
        onError,
    });

    const handleOpenDeleteConfirmation: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        setIsDeleteConfirmationOpen(true);
    };

    const handleSubmit = () => {
        mutate({
            orderId: {
                value: id,
            },
        });
    };

    const handleCloseDeleteConfirmation = () => {
        setIsDeleteConfirmationOpen(false);
    };

    const handleonDecline: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        onDecline?.();
    };

    return (
        <>
            <Group justify='flex-end'>
                <Button
                    title='Удалить'
                    color='red'
                    disabled={isPending}
                    loading={isPending}
                    onClick={handleOpenDeleteConfirmation}
                >
                    Удалить
                </Button>

                {onDecline && (
                    <Button
                        title='Отмена'
                        disabled={isPending}
                        onClick={handleonDecline}
                    >
                        Отмена
                    </Button>
                )}
            </Group>

            <ConfirmationDialog
                opened={isDeleteConfirmationOpen}
                title='Удаление ордера'
                message='Вы уверены, что хотите удалить ордер?'
                confirmText='Удалить'
                cancelText='Отмена'
                loading={isPending}
                onConfirm={handleSubmit}
                onCancel={handleCloseDeleteConfirmation}
            />
        </>
    );
};
